import { UpgradePlanForm } from "../components/UpgradePlanForm";

export default function UpgradePage() {
  return (
    <div className="px-4 sm:px-6 lg:mx-auto lg:max-w-6xl lg:px-8 pt-6">
      <UpgradePlanForm />
    </div>
  );
}
